var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line',{class:{ 'network-selection': _vm.selected,
              'network-background': !_vm.selected,
              'no-events': _vm.mode },attrs:{"x1":_vm.calculateX1,"y1":_vm.calculateY1,"x2":_vm.calculateX2,"y2":_vm.calculateY2,"stroke-width":_vm.calculateStrokeWidth}})}
var staticRenderFns = []

export { render, staticRenderFns }